module.exports = __webpack_public_path__ + "img/cam.1da537df.png";